import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DateRangePicker from '../../../commonComponents/DateRangePicker';
import moment from 'moment';
import {
  FiltersCard,
  FiltersRow,
  FilterGroup,
  SearchFilterGroup,
  FilterLabel,
  StyledInput,
  StyledSelect,
} from './Styles';
import {
  FILTER_LABELS,
  SORT_OPTIONS,
  ORDER_OPTIONS,
  SEARCH_PLACEHOLDER,
} from './constants';
import type { FiltersSectionProps } from './types';

const FiltersSection: React.FC<FiltersSectionProps> = ({
  startDate,
  endDate,
  searchTerm,
  sortBy,
  sortOrder,
  onDateRangeChange,
  onSearchChange,
  onSortChange,
}) => {
  const selectedDateRange = {
    startDate: moment(startDate),
    endDate: moment(endDate),
  };

  const handleDateChange = (range: { startDate: moment.Moment | null; endDate: moment.Moment | null }) => {
    if (range.startDate && range.endDate) {
      onDateRangeChange({
        startDate: range.startDate.format('YYYY-MM-DD'),
        endDate: range.endDate.format('YYYY-MM-DD'),
      });
    }
  };

  return (
    <FiltersCard>
      <FiltersRow>
        <FilterGroup>
          <FilterLabel>{FILTER_LABELS.DATE_RANGE}</FilterLabel>
          <DateRangePicker
            selectedDateRange={selectedDateRange}
            onDateRangeChange={handleDateChange}
            placeholder="Select date range"
          />
        </FilterGroup>
        <SearchFilterGroup>
          <FilterLabel>{FILTER_LABELS.SEARCH_MERCHANTS}</FilterLabel>
          <StyledInput
            placeholder={SEARCH_PLACEHOLDER}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            prefix={<FontAwesomeIcon icon={faSearch} />}
            allowClear
          />
        </SearchFilterGroup>
        <FilterGroup>
          <FilterLabel>{FILTER_LABELS.SORT_BY}</FilterLabel>
          <StyledSelect
            value={sortBy}
            onChange={(v) => onSortChange(String(v ?? ''), sortOrder)}
            options={SORT_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
          />
        </FilterGroup>
        <FilterGroup>
          <FilterLabel>{FILTER_LABELS.ORDER}</FilterLabel>
          <StyledSelect
            value={sortOrder}
            onChange={(v) => onSortChange(sortBy, v as 'asc' | 'desc')}
            options={ORDER_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
          />
        </FilterGroup>
      </FiltersRow>
    </FiltersCard>
  );
};

export default React.memo(FiltersSection);
